export default __webpack_public_path__ + "static/media/logo.c946593c.svg";